export default `.icon-dirty {
  --ids-icon-height-default: 12px !important;
  --ids-icon-width-default: 12px !important;
  position: absolute;
  color: var(--ids-input-dirty-indicator-color-background-dirty);
  top: 0;
}
.icon-dirty[dir=rtl] {
  transform: rotate(90deg);
  top: 0;
}
.icon-dirty.tab-dirty-tracker {
  inset-inline-start: 0;
}

.ids-color-picker .icon-dirty {
  margin-inline-start: 35px;
}

.ids-color-picker.compact .icon-dirty {
  margin-inline-start: 27px;
}

.ids-textarea .icon-dirty {
  top: 1px;
  margin-inline-start: 1px;
}
.ids-textarea .icon-dirty[dir=rtl] {
  top: 2px;
}

:host(:not([hidden])):not([color-variant=module]) {
  display: block;
}

:host(ids-tab:not([orientation=vertical]):not([color-variant=module]):first-child),
:host(ids-tab-more:not([orientation=vertical]):not([color-variant=module]):first-child),
.ids-tabs-container:not(.orientation-vertical):not(.color-variant-module) [class*=ids-tab]:first-child {
  margin-inline-start: var(--ids-space-3xs);
}

:host(ids-tab:not([orientation=vertical]):not([color-variant=module]):last-child),
:host(ids-tab-more:not([orientation=vertical]):not([color-variant=module]):last-child),
.ids-tabs-container:not(.orientation-vertical):not(.color-variant-module) [class*=ids-tab]:last-child {
  margin-inline-end: var(--ids-space-3xs);
}

:host(ids-tab:not([orientation=vertical]):not([color-variant=module]):not([color-variant=header]):not(:last-child)),
:host(ids-tab-more:not([orientation=vertical]):not([color-variant=module]):not(:last-child)),
.ids-tabs-container:not(.orientation-vertical):not(.color-variant-module) [class*=ids-tab]:not(:last-child) {
  margin-inline-end: var(--ids-space-3xs);
}

:host(ids-tab:focus-visible),
:host(ids-tab-more:focus-visible),
.ids-tab-container [class*=ids-tab]:focus-visible {
  outline: none;
}

:host(ids-tab:not([has-error])) slot[name=error] {
  display: none;
}

:host(ids-tab[value=app-menu]) {
  position: sticky;
  left: 0;
  z-index: 1;
}

:host(ids-tab[editable]) .ids-tab.tab-action-container {
  margin-inline-start: auto;
}
:host(ids-tab[editable]) .ids-tab {
  min-width: var(--ids-tab-min-width);
  max-width: var(--ids-tab-max-width);
}

:host(ids-tab[editing]) .ids-tab {
  max-width: unset;
}
:host(ids-tab[editing]) .ids-tab .tab-name-editor {
  min-width: var(--ids-tab-editor-input-min-width);
  max-width: var(--ids-tab-editor-input-max-width);
  width: calc(var(--text-width, --ids-tab-editor-input-min-width));
}
:host(ids-tab[editing]) .ids-tab #ids-icon-dirty-filled {
  display: none;
}
:host(ids-tab[editing]) .ids-tab.selected {
  color: unset;
}
:host(ids-tab[editing]) .ids-tab .tab-action-container .more-options-btn {
  display: none;
}

.tab-content {
  display: none;
}

.ids-tab {
  display: flex;
  position: relative;
  align-items: center;
  color: var(--ids-tab-color-text-default);
  box-sizing: border-box;
  height: 100%;
  padding-inline: var(--ids-space-2xs);
  padding-block: var(--ids-space-xs);
  list-style: none outside none;
  user-select: none;
  cursor: pointer;
}
.ids-tab:hover:not(.more):not(.selected) {
  color: var(--ids-tab-color-text-hover);
  background-color: var(--ids-tab-color-background-hover);
}
.ids-tab:hover:not(.more):not(.selected)::after, .ids-tab:hover:not(.more):not(.selected) .selection-underline {
  background-color: var(--ids-tab-color-border-bottom);
}
.ids-tab ids-text {
  flex-grow: 1;
  padding-block: 4px;
}
.ids-tab .tab-action-container {
  display: flex;
  gap: 4px;
}
.ids-tab:hover.more, .ids-tab.is-open.more {
  background-color: var(--ids-button-tertiary-color-background-hover);
}
.ids-tab.disabled {
  cursor: default;
  color: var(--ids-tab-color-text-disabled);
  pointer-events: none;
}
.ids-tab.selected {
  color: var(--ids-tab-color-text-selected);
  cursor: default;
}
.ids-tab.selected.disabled {
  opacity: var(--ids-opacity-disabled);
}
.ids-tab.selected.ids-text {
  font-weight: 700;
}
.ids-tab.selected::after, .ids-tab.selected .selection-underline {
  background-color: var(--ids-tab-color-selected-border-bottom);
}
.ids-tab.selected ids-menu-button:not(.more-options-btn)::part(button) {
  color: var(--ids-tab-color-text-selected);
}
.ids-tab.selected ids-menu-button:not(.more-options-btn)::part(button) .is-focused {
  border: 1px solid transparent;
}
.ids-tab.selected ids-menu-button:not(.more-options-btn)::part(button):focus, .ids-tab.selected ids-menu-button:not(.more-options-btn)::part(button):focus-within, .ids-tab.selected ids-menu-button:not(.more-options-btn)::part(button):focus-visible, .ids-tab.selected ids-menu-button:not(.more-options-btn)::part(button):active, .ids-tab.selected ids-menu-button:not(.more-options-btn)::part(button):target {
  border: 1px solid transparent;
  box-shadow: unset;
}
.ids-tab.selected ids-menu-button:not(.more-options-btn)::part(button):hover {
  background-color: transparent;
  border: 1px solid transparent;
}
.ids-tab.selected ids-menu-button.more-options-btn::part(button) {
  color: var(--ids-tab-color-text-selected);
}
.ids-tab.selected ids-menu-button.more-options-btn:hover {
  background-color: var(--ids-button-module-color-background-hover);
  border-radius: var(--ids-button-module-border-radius);
}
.ids-tab.actionable {
  cursor: pointer;
}
.ids-tab.count {
  padding-inline: 12px;
}
.ids-tab.count .ids-tab-count-container {
  display: flex;
  flex-direction: column;
}
.ids-tab:focus-visible {
  outline: none;
}
.ids-tab .ids-tab-trigger-container {
  display: flex;
  place-content: center;
}
.ids-tab .ids-tab-trigger-container[hidden] {
  display: none;
}
.ids-tab.orientation-horizontal:not(.count) {
  padding-top: var(--ids-space-xs);
}
.ids-tab.orientation-horizontal:not(.color-variant-module) {
  border-bottom: 1px solid transparent;
  background-color: var(--ids-tab-color-background-default);
  border-radius: var(--ids-tab-border-radius-masthead);
  height: var(--ids-tab-full-height-masthead);
}
.ids-tab.orientation-horizontal:not(.color-variant-module):focus-visible {
  outline: none;
}
.ids-tab.orientation-horizontal:not(.color-variant-module):focus-visible:not(.hide-focus):not(.more)::before {
  border: 1px solid var(--ids-color-action-default);
  position: absolute;
  inset-block-start: 0px;
  inset-inline-start: -1px;
  width: calc(100% - -1px);
  height: calc(100% - 1px);
  content: "";
  pointer-events: none;
}
.ids-tab.orientation-horizontal:not(.color-variant-module):focus-visible.color-variant-module::before {
  border: 1px solid var(--ids-tab-module-color-focus-border);
  border-radius: 6px;
  position: absolute;
  inset-block-start: 0px;
  inset-inline-start: -1px;
  width: calc(100% - -1px);
  height: calc(100% - 0px);
  content: "";
  pointer-events: none;
}
.ids-tab.orientation-horizontal:not(.color-variant-module).selected, .ids-tab.orientation-horizontal:not(.color-variant-module):hover:not(.more), .ids-tab.orientation-horizontal:not(.color-variant-module).disabled {
  border-bottom: 1px solid transparent;
}
.ids-tab.orientation-horizontal:not(.color-variant-module).selected::after, .ids-tab.orientation-horizontal:not(.color-variant-module).selected .selection-underline, .ids-tab.orientation-horizontal:not(.color-variant-module):hover:not(.more)::after, .ids-tab.orientation-horizontal:not(.color-variant-module):hover:not(.more) .selection-underline, .ids-tab.orientation-horizontal:not(.color-variant-module).disabled::after, .ids-tab.orientation-horizontal:not(.color-variant-module).disabled .selection-underline {
  position: absolute;
  height: 3px;
  inset-block-end: 0;
  inset-inline: 0;
  z-index: 1;
  pointer-events: none;
  content: "";
}
.ids-tab.orientation-horizontal ids-menu-button::part(button):hover {
  background-color: transparent;
  border: 1px solid transparent;
}
.ids-tab.has-sub-tabs {
  height: 100%;
}
.ids-tab.has-sub-tabs ids-menu-button::part(button):hover {
  background-color: unset;
}
.ids-tab ids-text::part(text),
.ids-tab .ids-tab.ids-text {
  padding-inline: 8px;
}
.ids-tab.swappable {
  padding-inline-start: var(--ids-space-xs);
  padding-inline-end: 6px;
}

.ids-tab.orientation-vertical {
  padding-inline: var(--ids-space-md);
  display: flex;
  align-items: center;
  flex-direction: row;
  justify-content: flex-start;
  width: 100%;
  height: 42px;
  background-color: var(--ids-tab-vertical-color-background-default);
  color: var(--ids-tab-vertical-color-text-default);
}
.ids-tab.orientation-vertical ids-icon {
  margin-inline-end: 8px;
}
.ids-tab.orientation-vertical ids-text[overflow=ellipsis] {
  margin-inline-end: 8px;
}
.ids-tab.orientation-vertical.count {
  padding-inline: 12px;
}
.ids-tab.orientation-vertical.count .ids-tab-count-container {
  display: flex;
  flex-direction: row;
  align-items: center;
}
.ids-tab.orientation-vertical ids-text::part(text),
.ids-tab.orientation-vertical .ids-tab.ids-text {
  display: inline-flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-between;
}
.ids-tab.orientation-vertical:hover {
  background-color: var(--ids-tab-vertical-color-background-hover);
  color: var(--ids-tab-vertical-color-text-hover);
}
.ids-tab.orientation-vertical:focus:not(:focus-visible) {
  border: 1px solid var(--ids-tab-module-color-focus-border);
  padding-inline: calc(var(--ids-space-md) - 1px);
}
.ids-tab.orientation-vertical.disabled {
  background-color: var(--ids-tab-vertical-color-background-disabled);
  color: var(--ids-tab-vertical-color-text-disabled);
}
.ids-tab.orientation-vertical:focus-visible {
  outline: none;
}
.ids-tab.orientation-vertical:focus-visible:not(.hide-focus):not(.more)::before {
  border: 1px solid var(--ids-color-action-default);
  position: absolute;
  inset-block-start: 1px;
  inset-inline-start: 1px;
  width: calc(100% - 3px);
  height: calc(100% - 3px);
  content: "";
  pointer-events: none;
}
.ids-tab.orientation-vertical:focus-visible.color-variant-module::before {
  border: 1px solid var(--ids-tab-module-color-focus-border);
  border-radius: 6px;
  position: absolute;
  inset-block-start: 1px;
  inset-inline-start: 1px;
  width: calc(100% - 3px);
  height: calc(100% - 2px);
  content: "";
  pointer-events: none;
}
.ids-tab.orientation-vertical.selected {
  background-color: var(--ids-tab-vertical-color-background-selected);
  color: var(--ids-tab-vertical-color-text-selected);
}
.ids-tab.orientation-vertical.selected:focus-visible:not(.hide-focus)::after, .ids-tab.orientation-vertical.selected:focus-visible:not(.hide-focus) .selection-underline {
  background-color: var(--ids-tab-vertical-color-border-selected);
}

:host(ids-tab[color-variant=module]:not(:last-child):not([value=add]):not([value=reset])) {
  background-color: var(--ids-tab-module-color-body-background);
  display: flex;
  align-items: center;
  justify-content: center;
  border-inline-end: 4px solid transparent;
}

:host(ids-tab[color-variant=module][value=add]),
:host(ids-tab[color-variant=module][value=reset]) {
  border-inline-end: 1px solid var(--ids-tab-module-color-border-right);
}

:host(ids-tab[color-variant=module][selected]) {
  align-items: flex-end;
  background: linear-gradient(to bottom, var(--ids-tab-module-color-body-background) 0%, var(--ids-tab-module-color-body-background) 85%, var(--ids-tab-module-color-background-selected) 15%, var(--ids-tab-module-color-background-selected) 100%);
}

:host(ids-tab[color-variant=module]:focus-visible) .ids-tab:not(.disabled),
:host(ids-tab[color-variant=module]:hover) .ids-tab:not(.disabled) {
  border: 0;
  background-color: var(--ids-tab-module-color-background-selected);
  outline: none;
}

:host(ids-tab[color-variant=module]:focus-visible[selected]) .ids-tab.is-focused {
  border-inline: 1px solid;
  border-block-start: 1px solid;
  border-block-end: 0;
  outline: none;
}

:host(ids-tab[color-variant=module]),
.ids-tabs-container.color-variant-module .ids-tabs-list-more {
  height: 43px;
}

.ids-tab.color-variant-module:not(.add):not(.reset):not(.more) {
  min-width: 169px;
  height: 36px;
  flex: 1;
  border-radius: 6px;
  padding-inline: 10px;
}
.ids-tab.color-variant-module:not(.add):not(.reset):not(.more).selected {
  border-radius: 6px 6px 0 0;
  background-color: var(--ids-tab-module-color-background-selected);
  height: 34.5px;
  border-inline: 1px solid var(--ids-color-transparent);
  border-block-start: 1px solid var(--ids-color-transparent);
  border-block-end: 0;
}
.ids-tab.color-variant-module:not(.add):not(.reset):not(.more).selected::before {
  content: " ";
  border: 0;
  position: absolute;
  right: -5px;
  bottom: -4.5px;
  width: 4px;
  height: 7px;
  border-radius: 0 0 0 6px;
  background: var(--ids-tab-module-color-body-background);
  box-shadow: 0 2px 0 0 var(--ids-tab-module-color-background-selected);
  inset-block-start: unset;
  inset-inline-start: unset;
}
.ids-tab.color-variant-module:not(.add):not(.reset):not(.more).selected::after {
  content: " ";
  border: 0;
  position: absolute;
  left: -5px;
  bottom: -4.5px;
  width: 4px;
  height: 7px;
  border-radius: 0 0 6px;
  background: var(--ids-tab-module-color-body-background);
  box-shadow: 0 2px 0 0 var(--ids-tab-module-color-background-selected);
}
.ids-tab.color-variant-module:not(.add):not(.reset):not(.more).selected.is-focused:not(.hide-focus)::after {
  border-inline-end: 1px solid;
}
.ids-tab.color-variant-module:not(.add):not(.reset):not(.more).selected.is-focused:not(.hide-focus)::before {
  border-inline-start: 1px solid;
}

:host(ids-tab[color-variant=module]:not([orientation=vertical]):not([actionable])),
:host(ids-tab-more[color-variant=module]:not([orientation=vertical]):not([actionable])),
.ids-tab-container.color-variant-module:not(.orientation-vertical):not(.actionable) [class*=ids-tab] {
  flex-grow: 1;
}

.ids-tab.color-variant-module {
  outline: none;
  background-color: var(--ids-tab-module-color-background-default);
  color: var(--ids-tab-module-color-text-default);
  justify-content: center;
  border-bottom: 1px solid var(--ids-tab-module-tab-color-border-bottom);
}
.ids-tab.color-variant-module:hover:not(.more):not(.selected) {
  color: var(--ids-tab-module-color-text-hover);
  background-color: var(--ids-tab-module-color-background-hover);
}
.ids-tab.color-variant-module:hover.more {
  color: var(--ids-tab-module-color-text-hover);
  background-color: var(--ids-tab-module-color-background-hover);
}
.ids-tab.color-variant-module.selected {
  background-color: var(--ids-tab-module-color-background-selected);
  color: var(--ids-tab-module-color-text-selected);
}
.ids-tab.color-variant-module:not(.selected):focus-visible {
  outline: none;
}
.ids-tab.color-variant-module:not(.selected):focus-visible:not(.hide-focus):not(.more)::before {
  border: 1px solid var(--ids-color-action-default);
  position: absolute;
  inset-block-start: 1px;
  inset-inline-start: 1px;
  width: calc(100% - 3px);
  height: calc(100% - 3px);
  content: "";
  pointer-events: none;
}
.ids-tab.color-variant-module:not(.selected):focus-visible.color-variant-module::before {
  border: 1px solid var(--ids-tab-module-color-focus-border);
  border-radius: 6px;
  position: absolute;
  inset-block-start: 1px;
  inset-inline-start: 1px;
  width: calc(100% - 3px);
  height: calc(100% - 2px);
  content: "";
  pointer-events: none;
}
.ids-tab.color-variant-module.disabled {
  background-color: var(--ids-tab-module-color-background-disabled);
  color: var(--ids-tab-module-color-text-disabled);
}
.ids-tab.color-variant-module > ids-text,
.ids-tab.color-variant-module > .ids-text {
  padding-bottom: 3px;
  text-align: center;
}
.ids-tab.color-variant-module:not(.actionable) {
  min-width: var(--ids-tab-min-width);
}
.ids-tab.color-variant-module.more {
  min-width: var(--ids-tab-more-button-width);
  height: calc(var(--ids-tab-module-height) + 1px);
}
.ids-tab.color-variant-module.actionable {
  min-width: 41px;
  gap: 0;
  height: calc(var(--ids-tab-module-height));
  margin-inline: 1px;
}
.ids-tab.color-variant-module.dismissible {
  justify-content: space-around;
}
.ids-tab.color-variant-module.dismissible > ids-text,
.ids-tab.color-variant-module.dismissible > .ids-text {
  flex-grow: 1;
}
.ids-tab.color-variant-module.dismissible.selected:not(.disabled) ::slotted(ids-trigger-button),
.ids-tab.color-variant-module.dismissible.selected:not(.disabled) > .ids-trigger-button,
.ids-tab.color-variant-module.dismissible.selected:not(.disabled) > ids-trigger-button, .ids-tab.color-variant-module.dismissible.is-focused:not(.disabled) ::slotted(ids-trigger-button),
.ids-tab.color-variant-module.dismissible.is-focused:not(.disabled) > .ids-trigger-button,
.ids-tab.color-variant-module.dismissible.is-focused:not(.disabled) > ids-trigger-button {
  color: var(--ids-tab-module-dimissible-color);
  visibility: visible;
}
.ids-tab.color-variant-module.dismissible ::slotted(ids-trigger-button),
.ids-tab.color-variant-module.dismissible > .ids-trigger-button,
.ids-tab.color-variant-module.dismissible > ids-trigger-button {
  flex-grow: 0;
  flex-shrink: 1;
  visibility: hidden;
}
.ids-tab.color-variant-module.dismissible:hover ::slotted(ids-trigger-button),
.ids-tab.color-variant-module.dismissible:hover > .ids-trigger-button,
.ids-tab.color-variant-module.dismissible:hover > ids-trigger-button {
  visibility: visible;
}

.ids-tab.color-variant-alternate {
  color: var(--ids-tab-alternate-color-text-default);
}
.ids-tab.color-variant-alternate:hover {
  color: var(--ids-tab-alternate-color-text-hover);
}
.ids-tab.color-variant-alternate:hover::after {
  background-color: var(--ids-tab-alternate-color-background-hover);
}
.ids-tab.color-variant-alternate.selected {
  color: var(--ids-tab-alternate-color-text-selected);
}
.ids-tab.color-variant-alternate.selected::after, .ids-tab.color-variant-alternate.selected .selection-underline {
  background-color: var(--ids-tab-alternate-horizontal-color-background);
}
.ids-tab.color-variant-alternate.disabled {
  color: var(--ids-tab-alternate-color-text-disabled);
}
.ids-tab.color-variant-alternate.disabled.selected {
  color: var(--ids-tab-alternate-color-text-disabled);
}
.ids-tab.color-variant-alternate.disabled.selected::after, .ids-tab.color-variant-alternate.disabled.selected .selection-underline {
  background-color: var(--ids-tab-alternate-color-text-disabled);
}
.ids-tab.color-variant-alternate:not(.hide-focus):focus-visible, .ids-tab.color-variant-alternate:not(.hide-focus):focus, .ids-tab.color-variant-alternate:not(.hide-focus):focus-within {
  border-color: var(--ids-tab-alternate-color-border-focus);
}

.ids-tab.color-variant-header {
  color: var(--ids-tab-header-color-text-default);
}
.ids-tab.color-variant-header:hover {
  background-color: var(--ids-tab-header-color-background-hover);
  color: var(--ids-tab-header-color-text-hover);
}
.ids-tab.color-variant-header.selected {
  color: var(--ids-tab-header-color-text-selected);
}
.ids-tab.color-variant-header.selected::after, .ids-tab.color-variant-header.selected .selection-underline {
  background-color: var(--ids-tab-header-color-text-selected);
}
.ids-tab.color-variant-header.disabled {
  color: var(--ids-tab-header-color-text-disabled);
}
.ids-tab.color-variant-header:not(.hide-focus):focus-visible, .ids-tab.color-variant-header:not(.hide-focus):focus, .ids-tab.color-variant-header:not(.hide-focus):focus-within {
  border-color: var(--ids-tab-header-color-border-focus);
}
.ids-tab.color-variant-header.actionable {
  border-bottom: 0;
  padding-inline: 7px;
  padding-block-start: 7px;
  width: var(--ids-tab-header-button-width);
}
.ids-tab.color-variant-header.actionable:first-child {
  border-inline-start: 1px solid var(--ids-tab-divider-color-border);
}
.ids-tab.color-variant-header.actionable:hover {
  border-bottom: none;
  background-color: var(--ids-tab-header-color-background-hover);
  color: var(--ids-tab-header-color-text-hover);
}
.ids-tab.color-variant-header.actionable:hover::after {
  background-color: var(--ids-tab-header-color-background-hover);
}
.ids-tab.color-variant-header.actionable.add {
  border-inline-start: 1px solid var(--ids-tab-divider-color-border);
}
.ids-tab.color-variant-header.more.orientation-horizontal:not(.color-variant-module) {
  --ids-tab-divider-width: var(--ids-tab-header-button-width);
  border-inline-start: none;
}
.ids-tab.color-variant-header.more.orientation-horizontal:not(.color-variant-module) .tab-more-text > *:not(.last-child) {
  padding-inline-end: 2px;
}

.tab-more-text {
  display: inline-flex;
  align-items: center;
  padding-inline-end: 3px;
}
.tab-more-text > *:not(.last-child) {
  padding-inline-end: 3px;
  padding-block-start: 2px;
}
.tab-more-text ids-text,
.tab-more-text .ids-text {
  display: inline-block;
}

ids-popup-menu,
.ids-popup-menu {
  position: absolute;
  width: 100%;
}

.ids-tab:not(.more) ::slotted(ids-icon) {
  color: currentColor;
  pointer-events: none;
}

.ids-tab.is-focused,
.ids-tab .is-focused {
  outline: none;
}
.ids-tab.is-focused:not(.hide-focus):not(.more)::before,
.ids-tab .is-focused:not(.hide-focus):not(.more)::before {
  border: 1px solid var(--ids-color-action-default);
  position: absolute;
  inset-block-start: 0px;
  inset-inline-start: -1px;
  width: calc(100% - -1px);
  height: calc(100% - 1px);
  content: "";
  pointer-events: none;
}
.ids-tab.is-focused.color-variant-module::before,
.ids-tab .is-focused.color-variant-module::before {
  border: 1px solid var(--ids-tab-module-color-focus-border);
  border-radius: 6px;
  position: absolute;
  inset-block-start: 0px;
  inset-inline-start: -1px;
  width: calc(100% - -1px);
  height: calc(100% - 0px);
  content: "";
  pointer-events: none;
}

.ids-tab.more.orientation-horizontal:not(.color-variant-module) {
  border-inline-start: 1px solid var(--ids-tab-divider-color-border);
  border-bottom: 0 solid transparent;
  margin-inline-end: 2px;
  height: var(--ids-tab-divider-width);
  width: var(--ids-tab-divider-width);
}
.ids-tab.more.orientation-horizontal:not(.color-variant-module).is-focused {
  background-color: var(--ids-button-menu-background-color-active);
}
.ids-tab.more.orientation-horizontal:not(.color-variant-module)::after {
  content: "";
  position: absolute;
  height: 44px;
  width: 44px;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  cursor: pointer;
  z-index: 2;
}

::slotted(ids-trigger-button) {
  align-items: center;
  color: currentColor;
  cursor: pointer;
  display: flex;
  justify-content: center;
  margin-inline-start: 4px;
  margin-inline-end: var(--ids-tab-dismiss-button-offset);
  place-self: center;
}

::slotted(ids-trigger-button.ids-tab-close-button) {
  margin-inline-start: unset;
}

::slotted(.ids-tab-more-menu-item-text) {
  display: inline-block;
  margin-inline-start: var(--ids-space-2xs);
}
/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */`;
